import { createGlobalStyle, ThemeProvider } from 'styled-components'
import '../public/css/app.css'
  
const GlobalStyle = createGlobalStyle``

const theme = {
  colors: {
    primary: '#0070f3',
  },
}

export default function App({ Component, pageProps }) {
  return (
    <>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <Component {...pageProps} />
      </ThemeProvider>
    </>
  )
}
